import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { DoorReleaseDialog } from '../DoorDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { DoorDto } from '../../../../core/dto/device/doors/door.dto'

export const DoorReleaseButton = () => {
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const { record: door, refetch } = useShowContext<DoorDto>()
  const [stateDialogOpen, setStateDialogOpen] = useState(false)
  const [mutate, { loading: mutationLoading }] = useMutation()

  const handleCloseDialog = () => {
    setStateDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setStateDialogOpen(true)
  }

  const handleSetReleased = async (released: boolean) => {
    handleCloseDialog()
    await mutate(
      {
        type: sanitizeFetchType('setDoorReleased'),
        resource: ResourceName.DOORS,
        payload: {
          doorId: door?.id,
          released,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refetch?.()
  }

  return (
    <>
      <DoorReleaseDialog
        open={stateDialogOpen}
        close={handleCloseDialog}
        handleSetReleased={handleSetReleased}
      />
      <Button
        variant="contained"
        color="primary"
        label="resources.doors.actions.setState"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DOORS_SET_RELEASE) ||
          loading ||
          mutationLoading
        }
        onClick={handleOpenDialog}
      />
    </>
  )
}
